document.addEventListener("DOMContentLoaded", function () {
  initHeroParallax();
  initSmoothScroll();
});

function initHeroParallax() {
  const heroContent = document.querySelector(".tripsitter-hero__content-inner");

  if (!heroContent) return;

  // Check for reduced motion preference
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  heroContent.classList.add("parallax");

  function updateParallax() {
    const scrolled = window.pageYOffset;
    const heroHeight = window.innerHeight;

    // Only apply parallax while hero is visible
    if (scrolled < heroHeight) {
      const parallaxOffset = scrolled * 0.5; // Adjust speed (0.5 = half scroll speed)
      heroContent.style.setProperty("--parallax-offset", `${parallaxOffset}px`);
    }
  }

  // Use requestAnimationFrame for smooth performance
  let ticking = false;

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  function handleScroll() {
    requestTick();
    ticking = false;
  }

  window.addEventListener("scroll", handleScroll, { passive: true });
}

function initSmoothScroll() {
  const ctaButton = document.querySelector(".tripsitter-hero__cta");

  if (!ctaButton) return;

  ctaButton.addEventListener("click", function (e) {
    const href = this.getAttribute("href");

    // Check if it's an anchor link to a section on the same page
    if (href && href.startsWith("#")) {
      e.preventDefault();

      const targetSection = document.querySelector(href);

      if (targetSection) {
        const headerOffset = 80; // Adjust for any fixed header
        const elementPosition = targetSection.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  });
}
